import { motion, AnimatePresence } from "framer-motion";
import "../styles/ContactPopup.css";

export default function ContactPopup({ open, onClose }) {

  /* OVERLAY FADE */
  const overlayVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.4 } },
    exit: { opacity: 0, transition: { duration: 0.3 } },
  };

  /* CARD ENTER */
  const cardVariants = {
    hidden: { opacity: 0, y: 80, scale: 0.96 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
    },
    exit: {
      opacity: 0,
      y: 60,
      scale: 0.96,
      transition: { duration: 0.35 },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.9, ease: "easeOut" },
    },
  };

  const wordContainer = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
  };

  const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const line1 = "Begin Your Journey".split(" ");
  const line2 = "Today".split(" ");

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="contact-popup-overlay"
          variants={overlayVariants}
          initial="hidden"
          animate="show"
          exit="exit"
        >
          <motion.div
            className="contact-card m-0 text-white rounded-3 p-4 p-md-5"
            variants={cardVariants}
            initial="hidden"
            animate="show"
            exit="exit"
          >
            {/* CLOSE */}
            <button className="popup-close" onClick={onClose}>✕</button>

            <div className="row g-4 g-md-5">

              {/* LEFT */}
              <div className="col-lg-6">
                <motion.h2
                  className="contact-titles display-4 mb-4"
                  variants={wordContainer}
                  initial="hidden"
                  animate="show"
                >
                  {line1.map((word, i) => (
                    <motion.span
                      key={i}
                      variants={wordVariant}
                      style={{ display: "inline-block", marginRight: "0.35em" }}
                    >
                      {word}
                    </motion.span>
                  ))}
                  <br />
                  {line2.map((word, i) => (
                    <motion.span
                      key={i}
                      variants={wordVariant}
                      style={{ display: "inline-block", marginRight: "0.35em" }}
                    >
                      {word}
                    </motion.span>
                  ))}
                </motion.h2>

                <motion.p className="contact-text" variants={fadeUp}>
                  Share your details and help us understand your requirements.
                  Explore thoughtfully crafted homes designed for refined living.
                  Receive personalized assistance from our experienced team.
                  We’ll get in touch to guide you every step of the way.
                </motion.p>
              </div>

              {/* RIGHT */}
              <div className="col-lg-6">
                <motion.div className="contact-form" variants={fadeUp}>

                  <motion.div className="mb-3" variants={fadeUp}>
                    <input className="form-control" placeholder="First Name" />
                  </motion.div>

                  <motion.div className="mb-3" variants={fadeUp}>
                    <input className="form-control" placeholder="+91 (0000) 000-000" />
                  </motion.div>

                  <motion.div className="mb-3" variants={fadeUp}>
                    <input className="form-control" placeholder="Your email" />
                  </motion.div>

                  <motion.div className="mb-4" variants={fadeUp}>
                    <textarea className="form-control" rows="4" placeholder="Your message" />
                  </motion.div>

                  <motion.button
                    className="location-btn"
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                  >
                    Send Message
                    <i className="fa-solid fa-arrow-right ms-2"></i>
                  </motion.button>

                </motion.div>
              </div>

            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
